export default __webpack_public_path__ + "static/char-thumb-32-791543bded7ca5fad8a94e13993198de.png";